export default {
  ADMIN_GATEKEEPER_ADMIN_USERS_REQUESTED: 'ADMIN_GATEKEEPER_ADMIN_USERS_REQUESTED',
  ADMIN_GATEKEEPER_ADMIN_USERS_REQUEST_SUCCEEDED: 'ADMIN_GATEKEEPER_ADMIN_USERS_REQUEST_SUCCEEDED',
  ADMIN_GATEKEEPER_ADMIN_USERS_REQUEST_FAILED: 'ADMIN_GATEKEEPER_ADMIN_USERS_REQUEST_FAILED',
  ADMIN_GATEKEEPER_RESET: 'ADMIN_GATEKEEPER_RESET',
};